import LandingNavbar from "../../components/LandingNavbar/LandingNavbar";
import TopBanner from "../../components/TopBanner/TopBanner";
import CoreValues from "./CoreValues/CoreValues";
import Waitlist from "../../components/Waitlist/Waitlist";
import Footer from "../../components/Footer/Footer";
import "./About.css";

import { Helmet } from "react-helmet-async";
import { People } from "../../components/IconsImport";

const About = () => {
  return (
    <>
      <Helmet>
        {/* PRIMARY SEO */}
        <title>
          About Xyncely | Campaign Execution Infrastructure
        </title>

        <meta
          name="description"
          content="Xyncely is building the operating infrastructure for influencer campaign execution, connecting brands, vendors, creators and internal teams in one workflow."
        />

        <meta
          name="robots"
          content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        />

        <link
          rel="canonical"
          href="https://xyncely.com/about"
        />

        {/* OPEN GRAPH */}
        <meta property="og:type" content="website" />

        <meta
          property="og:site_name"
          content="Xyncely"
        />

        <meta
          property="og:locale"
          content="en_IN"
        />

        <meta
          property="og:title"
          content="About Xyncely | Campaign Execution Infrastructure"
        />

        <meta
          property="og:description"
          content="Xyncely is building the operating infrastructure for influencer campaign execution, connecting brands, vendors, creators and internal teams in one workflow."
        />

        <meta
          property="og:url"
          content="https://xyncely.com/about"
        />

        <meta
          property="og:image"
          content="https://xyncely.com/assets/xyncely-og-1200x630.png"
        />

        <meta
          property="og:image:type"
          content="image/png"
        />

        <meta
          property="og:image:width"
          content="1200"
        />

        <meta
          property="og:image:height"
          content="630"
        />

        <meta
          property="og:image:alt"
          content="Xyncely - The Command Center for Influencer Marketing"
        />

        {/* TWITTER / X */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="About Xyncely | Campaign Execution Infrastructure"
        />

        <meta
          name="twitter:description"
          content="Xyncely is building the operating infrastructure for influencer campaign execution, connecting brands, vendors, creators and internal teams in one workflow."
        />

        <meta
          name="twitter:image"
          content="https://xyncely.com/assets/xyncely-og-1200x630.png"
        />

        <meta
          name="twitter:image:alt"
          content="Xyncely - The Command Center for Influencer Marketing"
        />
      </Helmet>

      <TopBanner />
      <LandingNavbar />

      {/* =========================
          About Hero
      ========================= */}

      <section className="about-hero">
        <div className="about-hero__content">

          <div className="about-hero__eyebrow">
            <span className="about-hero__icon">
              ♧
            </span>

            <span>
              A HUMAN PASSION FOR OPERATIONS
            </span>
          </div>

          <h1>
            Building the infrastructure
            <span> behind every campaign.</span>
          </h1>

          <p>
            We're a team of former marketers, engineers,
            and creators on a mission to eliminate
            spreadsheet chaos and replace it with
            ultimate clarity and creative control.
          </p>

        </div>
      </section>

      {/* =========================
          Our Story
      ========================= */}

      <section className="about-story">
        <div className="about-story__container">

          <div className="about-story__content">

            <span className="about-story__eyebrow">
              OUR STORY
            </span>

            <h2>
              We got tired of seeing good work
              get lost in the chaos.
            </h2>

            <p>
              Influencer marketing is built on people —
              brands, creators, marketers and teams working
              together to make something happen.
            </p>

            <p>
              But somewhere along the way, the work became
              scattered across spreadsheets, chats, emails
              and endless follow-ups.
            </p>

            <p>
              We kept thinking: there has to be a better way.
            </p>

            <p>
              That thought became Xyncely.
            </p>

            <p>
              We're building a space where the people
              running campaigns can spend less time
              managing the mess and more time doing the
              work that actually matters.
            </p>

            <p>
              Better collaboration. Clearer workflows.
              Fewer things falling through the cracks.
            </p>

            <p>
              That's what we're here for.
            </p>

          </div>

          <div className="about-story__image">
            <img
              src={People}
              alt="People collaborating"
            />
          </div>

        </div>
      </section>

      {/* =========================
          Core Values
      ========================= */}

      <CoreValues />

      {/* =========================
          Waitlist
      ========================= */}

      <Waitlist
        eyebrow="Be part of the journey"
        title="We're building the future of campaign ops"
        description="Join the brands and teams already shaping how influencer marketing gets done — smarter, faster, together."
        buttonText="Join the Waitlist"
        showProgress={true}
      />

      {/* =========================
          Footer
      ========================= */}

      <Footer />
    </>
  );
};

export default About;